import { render, staticRenderFns } from "./view-cloud.vue?vue&type=template&id=a8056efe"
import script from "./view-cloud.vue?vue&type=script&lang=ts"
export * from "./view-cloud.vue?vue&type=script&lang=ts"
import style0 from "./view-cloud.vue?vue&type=style&index=0&id=a8056efe&prod&lang=stylus"
import style1 from "./view-cloud.vue?vue&type=style&index=1&id=a8056efe&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./view-cloud.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports